import $ from "jquery";
import "select2/dist/js/select2.full.min";
import "select2/dist/js/i18n/ru";

class Module {
  constructor($module) {
    this.$module = $module;
    this.$industry = $module.find(".form-group_industry select");
    this.$country = $module.find(".form-group_country select");

    this.$taxAdvertiserCheckbox = $module.find(
      ".js-tax-advertiser-checkbox-row input[type=checkbox]"
    );
    this.$taxInfoGroup = $module.find(".js-tax-info-group");

    this.initSelect2();
    this.bindTaxHandler();
  }

  bindTaxHandler() {
    let _self = this;
    this.$taxAdvertiserCheckbox.change(function(e) {
      const endAdvertiser = $(this).is(":checked");
      if (endAdvertiser) {
        $("input", _self.$taxInfoGroup).attr("disabled", "disabled");
        _self.$taxInfoGroup.hide("fast");
      } else {
        $("input", _self.$taxInfoGroup).removeAttr("disabled", "disabled");
        _self.$taxInfoGroup.show("fast");
      }
    });

    this.$taxAdvertiserCheckbox.trigger("change");
  }

  initSelect2() {
    const self = this;

    this.$industry.select2();
    this.$country.select2({
      ajax: {
        data: function(params) {
          return {
            search: params.term,
            page: params.page || 1,
            code: [self.$country.data("code")]
          };
        },
        processResults: function(data) {
          return {
            results: data.items.map(function(i) {
              return {
                id: i.id,
                text: i.name
              };
            }),
            pagination: {
              more: data.pagination.page < data.pagination.total_pages
            }
          };
        }
      }
    });
  }
}

$(function() {
  $(".js-partner-register").each(function() {
    new Module($(this));
  });
});
